/* eslint-disable */
const JssPropTypes = {};

export default JssPropTypes;
